<template>
  <div class="m-container">
    <div class="m-home-container">
      <div class="m-home-head">
        <div class="m-home-top">
          画梦笔总公司数据
          <div @click="toUser()" class="m-home-close">
            <i class="el-icon-switch-button"></i>
          </div>
          <div class="m-timer-box">
            <div class="m-timer-p">
              <div class="m-timer-progress" :style="'width:'+ (progressNum(timerNum)) +'%'"></div>
            </div>
            <div class="m-timer-text">
              {{ getNowTime(timerNum) }} 刷新
            </div>
            <div style="margin-left: 10px">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link" style="color: #ffffff;">
                  {{ dropText }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="60">1分钟</el-dropdown-item>
                  <el-dropdown-item command="120">2分钟</el-dropdown-item>
                  <el-dropdown-item command="300">5分钟</el-dropdown-item>
                  <el-dropdown-item command="600">10分钟</el-dropdown-item>
                  <el-dropdown-item command="900">15分钟</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div class="m-home-cont">
<!--    左侧显示位    -->
        <div class="m-home-left" style="">
          <div class="m-top-box" v-if="moneyData.allMoney > 0">
            <DataNumItem :num="moneyData.allMoney/100" :title="'总金额'" :unit="'元'"></DataNumItem>
            <DataNumItem :num="moneyData.newMoney/100" :title="'新增金额'" :unit="'元'"></DataNumItem>
            <DataNumItem :num="moneyData.allVipMoney/100" :title="'总vip金额'" :unit="'元'"></DataNumItem>
            <DataNumItem :num="moneyData.allArticleMoney/100" :title="'总报告金额'" :unit="'元'"></DataNumItem>
            <DataNumItem :num="moneyData.payMoneyUserNum" :title="'消费人数'" :unit="'人'"></DataNumItem>
            <DataNumItem :num="moneyData.newPayUserNum" :title="'新增支付'" :unit="'项'"></DataNumItem>
            <DataNumItem :num="moneyData.cancelPayNum" :title="'取消支付'" :unit="'项'"></DataNumItem>
            <DataNumItem :num="moneyData.vipUserNum" :title="'vip人数'" :unit="'人'"></DataNumItem>
            <DataNumItem v-if="userData.noPayUser !== 0"
                         :num="Number((moneyData.payMoneyUserNum/userData.noPayUser*100).toFixed(0))"
                         :title="'支付率'" :unit="'%'"></DataNumItem>
          </div>
          <el-scrollbar>
            <div class="regional_table">
              <el-table :data="buyInfoList" v-loading="buyInfoLoading" style="width: 100%;" size="small" border>
                <el-table-column prop="phone" label="用户电话" width="100" align="center"></el-table-column>
                <el-table-column prop="description" label="购买名称" align="center"></el-table-column>
                <el-table-column prop="pay_money" label="购买价格" width="80" align="center"></el-table-column>
                <el-table-column prop="city_county_id" label="用户地区" width="120" align="center"></el-table-column>
                <el-table-column prop="pay_date" label="支付时间" width="120" align="center"></el-table-column>
              </el-table>
            </div>
          </el-scrollbar>
        </div>
<!--     右侧显示位   -->
        <div class="m-home-right">
          <div class="m-top-box" v-if="userData.allUser !== 0">
            <DataNumItem :num="userData.allUser" :title="'总用户'" :unit="'人'"></DataNumItem>
            <DataNumItem :num="userData.newUser" :title="'新增用户'" :unit="'人'"></DataNumItem>
            <DataNumItem :num="userData.idleUser" :title="'非区域用户'" :unit="'人'"></DataNumItem>
            <DataNumItem :num="userData.regionUser" :title="'合作区用户'" :unit="'人'"></DataNumItem>
            <DataNumItem :num="userData.salesmanToUser" :title="'业务员推送'" :unit="'人'"></DataNumItem>
            <DataNumItem :num="userData.loginUser" :title="'登录用户'" :unit="'人'"></DataNumItem>
            <DataNumItem :num="userData.noLoginUser" :title="'未登录'" :unit="'人'"></DataNumItem>
            <DataNumItem :num="userData.logOffUser" :title="'注销'" :unit="'人'"></DataNumItem>
            <DataNumItem :num="userData.noPayUser" :title="'未消费'" :unit="'人'"></DataNumItem>
          </div>
          <el-scrollbar>
            <div class="regional_table">
              <el-table :data="userInfoList" v-loading="buyInfoLoading2" style="width: 100%;" size="small" border>
                <el-table-column prop="phone" label="电话" align="center" width="100"></el-table-column>
                <el-table-column prop="city_name" label="用户地区" width="" align="center"></el-table-column>
                <el-table-column prop="create_date" label="注册时间" width="120" align="center"></el-table-column>
                <el-table-column prop="login_date" label="登录时间" width="120" align="center"></el-table-column>
              </el-table>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataNumItem from './Data_num_item'
export default {
  name: 'homeUserData',
  components: {
    DataNumItem
  },
  data () {
    return {
      dropText: '5分钟',
      timer: null,
      timerNum: 0,
      timerNumMax: 300,
      imitateShowInput: false,
      buyInfoLoading: false,
      buyInfoLoading2: false,
      buyInfoList: [],
      userInfoList: [],
      moneyData: {
        allMoney: 0, // 总金额
        newMoney: 0, // 新增金额
        allVipMoney: 0, // 总vip金额
        allArticleMoney: 0, // 总报告金额
        payMoneyUserNum: 0, // 消费人数
        newPayUserNum: 0, // 新增支付
        cancelPayNum: 0, // 取消支付
        vipUserNum: 0 // vip人数
      },
      userData: {
        allUser: 0, // 总用户
        newUser: 0, // 新增用户
        idleUser: 0, // 非区域用户
        regionUser: 0, // 合作区用户
        salesmanToUser: 0, // 业务员推送
        loginUser: 0, // 登录用户
        noLoginUser: 0, // 未登录
        logOffUser: 0, // 注销用户
        noPayUser: 0 // 未消费
      }
    }
  },
  methods: {
    // 下拉倒计时时间选项
    handleCommand (command) {
      this.timerNumMax = parseFloat(command).toFixed(0)
      this.timerNum = this.timerNumMax
      switch (command) {
        case '60':
          this.dropText = '1分钟'
          break
        case '120':
          this.dropText = '2分钟'
          break
        case '300':
          this.dropText = '5分钟'
          break
        case '600':
          this.dropText = '10分钟'
          break
        case '900':
          this.dropText = '15分钟'
          break
      }
    },
    // 退出监控跳转用户信息页
    toUser () {
      this.$router.push({name: 'home'})
    },
    // 支付数据
    loadMoneyData () {
      let _this = this
      this.$axios.post('/dataAnalysis/buyData')
        .then((res) => {
          if (res.status === 200) {
            _this.moneyData = res.data
          }
        })
    },
    // 用户数据
    loadUserData () {
      let _this = this
      this.$axios.post('/dataAnalysis/userData')
        .then((res) => {
          if (res.status === 200) {
            _this.userData = res.data
          }
        })
    },
    // 用户购买列表
    loadBuyList () {
      let _this = this
      this.buyInfoLoading = true
      this.$axios.post('/dataAnalysis/bayList')
        .then((res) => {
          if (res.status === 200) {
            _this.buyInfoList = res.data
            this.buyInfoLoading = false
          }
        })
    },
    // 用户列表
    loadUserList () {
      let _this = this
      this.buyInfoLoading2 = true
      this.$axios.post('/dataAnalysis/userList')
        .then((res) => {
          if (res.status === 200) {
            _this.userInfoList = res.data
            this.buyInfoLoading2 = false
          }
        })
    },
    // 秒转换分钟格式
    getNowTime (s) {
      // 计算时分秒数
      let min = parseInt(s / 60 % 60)
      let sec = parseInt(s % 60)
      // 个位数前补零
      min = min > 9 ? min : '0' + min
      sec = sec > 9 ? sec : '0' + sec
      return `${min} : ${sec}`
    },
    // 进度条宽度百分比
    progressNum (s) {
      let aa = s / this.timerNumMax * 100
      return parseFloat((100 - aa).toString()).toFixed(2)
    },
    // 加载数据
    loadAllApi () {
      this.loadMoneyData()
      this.loadUserData()
      this.loadBuyList()
      this.loadUserList()
      // 每隔5分钟定时刷新
      this.timerNum = this.timerNumMax
    }
  },
  mounted () {
    this.loadAllApi()
    this.timer = setInterval(() => {
      this.timerNum--
      if (this.timerNum <= 0) {
        this.loadAllApi()
      }
    }, 1000)
  },
  // 销毁时取消定时器
  beforeDestroy () {
    clearInterval(this.timer) // 清除定时器
    this.timer = null
  }
}
</script>

<style scoped src="../../assets/css/homeUserData.css"></style>



// WEBPACK FOOTER //
// src/components/home/HomeUserData.vue